import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../services/api.js';

const initialState = {
  currentDate: new Date(),
  events: [],
  selectedDate: null,
  selectedDateEvents: [],
  loading: false,
  error: '',
  lastFetchedKey: '',
};

export const fetchScheduleEvents = createAsyncThunk(
  'scheduleCalendar/fetchEvents',
  async ({ startDate, endDate }, { rejectWithValue }) => {
    try {
      const response = await api.get('/records/scheduled-events', {
        params: {
          startDate,
          endDate,
        },
      });
      return response.data || [];
    } catch (err) {
      const message = err?.response?.data?.message || 'Failed to load scheduled events';
      return rejectWithValue({ message });
    }
  }
);

const scheduleCalendarSlice = createSlice({
  name: 'scheduleCalendar',
  initialState,
  reducers: {
    setCurrentDate(state, action) {
      state.currentDate = action.payload;
    },
    setSelectedDate(state, action) {
      state.selectedDate = action.payload;
    },
    setSelectedDateEvents(state, action) {
      state.selectedDateEvents = action.payload;
    },
    clearSelectedDateEvents(state) {
      state.selectedDateEvents = [];
    },
    setError(state, action) {
      state.error = action.payload;
    },
    clearError(state) {
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchScheduleEvents.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(fetchScheduleEvents.fulfilled, (state, action) => {
        state.events = action.payload;
        state.loading = false;
        const { startDate, endDate } = action.meta.arg || {};
        state.lastFetchedKey = startDate && endDate ? `${startDate}|${endDate}` : '';
      })
      .addCase(fetchScheduleEvents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to load scheduled events';
      });
  },
});

export const {
  setCurrentDate,
  setSelectedDate,
  setSelectedDateEvents,
  clearSelectedDateEvents,
  setError,
  clearError,
} = scheduleCalendarSlice.actions;

export const selectScheduleCurrentDate = (state) => state.scheduleCalendar.currentDate;
export const selectScheduleEvents = (state) => state.scheduleCalendar.events;
export const selectScheduleSelectedDate = (state) => state.scheduleCalendar.selectedDate;
export const selectScheduleSelectedDateEvents = (state) =>
  state.scheduleCalendar.selectedDateEvents;
export const selectScheduleLoading = (state) => state.scheduleCalendar.loading;
export const selectScheduleError = (state) => state.scheduleCalendar.error;
export const selectScheduleLastFetchedKey = (state) => state.scheduleCalendar.lastFetchedKey;

export default scheduleCalendarSlice.reducer;
